import React, { useMemo } from 'react';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import { convertiUtsToDate } from '../GrapheXT/GrapheXT';
import { formatUniteArrayTable } from '../TableauDernieresValeursEtTotaux/TableauDernieresValeursEtTotaux';

const TableauDeltaDesBornesEtTotaux = ({
  configuration,
  donnees,
  viewobj_json_content,
  switchAfficherModifierIntervalle,
  dimensionWidth,
  dimensionHeight,
  donneesGraphe,
}) => {
  const generateTableData = useMemo(() => {
    if (!configuration || !donnees) {
      return { data: [], layout: {} };
    }

    let layout = {
      font: { size: 14 },
      title: {
        text: configuration.title + '<br>' + configuration.subtitle,
        font: { color: '#3c3935' },
      },
      showlegend: true,
      legend: {
        orientation: 'h',
        x: 0,
        y: -0.0,
      },
      ...(viewobj_json_content?.layout || {}),
    };

    let headers_values = [];
    let headers_unit = [];
    let sensors_names = [];
    let noms_responsables = [];
    let dates_values = [];
    let values = [];

    for (let curve of donnees) {
      let index_sensor_name = sensors_names.indexOf(curve.sensor_name);
      let index_prefix =
        curve.prefix === '' ? -1 : headers_values.indexOf(curve.prefix);
      let index_position_in_sensor =
        curve.position_in_sensor === ''
          ? -1
          : headers_values.indexOf(curve.position_in_sensor);

      const last_index = curve.y.length - 1;
      const new_date = curve.x[last_index];

      if (index_sensor_name < 0) {
        sensors_names.push(curve.sensor_name);
        noms_responsables.push(curve.name);
        dates_values.push(new_date);

        for (let ind_col = 0; ind_col < headers_values.length; ind_col++) {
          values[ind_col] = values[ind_col] || [];
          values[ind_col].push(null);
        }
      } else if (dates_values[index_sensor_name] < new_date) {
        dates_values[index_sensor_name] = new_date;
      }

      index_sensor_name =
        index_sensor_name < 0 ? sensors_names.length - 1 : index_sensor_name;

      if (index_prefix < 0) {
        values.push(new Array(sensors_names.length).fill(null));
        values[values.length - 1][index_sensor_name] =
          curve.y[last_index] - curve.y[0];

        headers_values.push(curve.prefix || curve.position_in_sensor);
        headers_unit.push(curve.engineering_unit);
      } else {
        const targetIndex =
          index_prefix > -1 ? index_prefix : index_position_in_sensor;
        values[targetIndex][index_sensor_name] =
          curve.y[last_index] - curve.y[0];
      }
    }

    dates_values = convertiUtsToDate(dates_values);
    dates_values.push(checkMot('totaux'));

    for (
      let index_colonne = 0;
      index_colonne < values.length;
      index_colonne++
    ) {
      let sum = values[index_colonne].reduce(
        (acc, val) => (!isNaN(val) ? acc + val : acc),
        0
      );

      values[index_colonne].push(sum);
      values[index_colonne] = formatUniteArrayTable(
        values[index_colonne],
        headers_unit[index_colonne]
      );
    }

    const headerColor = '#EFB805';
    const rowOthersColor = 'white';
    const rowLastColor = 'lightgrey';
    const fillCell = new Array(values[0].length).fill(rowOthersColor);
    fillCell[fillCell.length - 1] = rowLastColor;

    const data = [
      {
        type: 'table',
        columnwidth: [5, 18, 8, 5, 5],
        header: {
          values: [
            [checkMot('responsable')],
            [checkMot('nom')],
            [checkMot('date')],
            ...headers_values.map(
              (valeur, index) => `<b>${valeur} [${headers_unit[index]}]</b>`
            ),
          ],
          align: ['left', 'center'],
          line: { width: 1, color: '#000000' },
          fill: { color: headerColor },
          font: { family: 'Arial', size: 20, color: 'white' },
        },
        cells: {
          values: [noms_responsables, sensors_names, dates_values, ...values],
          align: ['left', 'center'],
          line: { color: '#000000' },
          fill: { color: [fillCell] },
          font: { family: 'Arial', size: 18, color: ['#506784'] },
          height: 25,
        },
      },
    ];

    return { data, layout };
  }, [configuration, donnees, viewobj_json_content]);

  return (
    <BibliothequePlotly
      data={generateTableData.data}
      layout={{
        ...generateTableData.layout,
        responsive: true,
        ...viewobj_json_content,
      }}
      donneesGraphe={donneesGraphe}
      ouvrirPopupModifierIntervalle={switchAfficherModifierIntervalle}
      dimensionWidth={dimensionWidth}
      dimensionHeight={dimensionHeight}
      viewobj_json_content={viewobj_json_content}
    />
  );
};

export default TableauDeltaDesBornesEtTotaux;
